import { filterListStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterList";
import { ButtonIcon, ButtonWrapper } from "@insite/mobius/Button";
import { clearBtnStyle } from "@waytek/Utilities/styleguide/btnIcon";
import { colorPalette, mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

filterListStyles.wrapper = {
    ...filterListStyles.wrapper,

    css: css`
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        ${mediaQueriesBP.minMD} {
            padding-top: 8px;
        }
    `,
};

filterListStyles.filterText = {
    ...filterListStyles.filterText,

    size: 18,
    weight: 500,
    lineHeight: 1.33,
    color: "#363636",

    css: css`
        margin-bottom: 10px;
    `,
};

filterListStyles.skipFiltersButtonWrapper = {
    ...filterListStyles.skipFiltersButtonWrapper,

    css: css`
        display: none;
    `,
};

filterListStyles.filterTag = {
    ...filterListStyles.filterTag,

    mergeCss: true,
    css: css`
        align-items: center;
        font-size: 14px;
        display: inline-flex;
        margin-right: 0;
        max-width: none;

        ${ButtonWrapper} {
            ${clearBtnStyle}

            min-height: auto;

            &:not(:disabled):hover {
                background: none;
                color: ${colorPalette.common.global.white};

                ${ButtonIcon} {
                    color: ${colorPalette.common.global.white};
                }
            }
        }
    `,
};

filterListStyles.clearAllLink = {
    ...filterListStyles.clearAllLink,

    css: css`
        margin-bottom: 10px;
    `,
};
